export class ConfigType {
    static readonly DAT = {
        title: 1,
        configs: 2,
        interfaces: 3,
        media: 4,
        versionList: 5,
        textures: 6,
    };

    static readonly DAT2 = {
        underlays: 1,
        identkits: 3,
        overlays: 4,
        inv: 5,
        locs: 6,
        enums: 8,
        npcs: 9,
        objs: 10,
        params: 11,
        seqs: 12,
        spotAnims: 13,
        varbits: 14,
        varps: 16,
        varClient: 19,
        varClientString: 15,
        varPlayer: 16,
    };

    static readonly OSRS = {
        hitSplat: 32,
        healthBar: 33,
        struct: 34,
        mapFunctions: 35,
        dbRow: 38,
        dbTable: 39,
    };

    static readonly RS2 = {
        bas: 32,
        mapScenes: 34,
        quests: 35,
        mapFunctions: 36,
    };
}
